import React from "react";
import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

interface IScratchPayUnavailableBannerProps {
  message: string;
}

export const ScratchPayUnavailableBanner = ({
  message,
}: IScratchPayUnavailableBannerProps) => {
  return (
    <Box
      role="alert"
      className="flex items-start gap-3 px-4 py-3 rounded-xl border bg-white w-full"
      sx={{ borderColor: "taupe.dark" }}
    >
      <ErrorOutlineIcon sx={{ color: "error.main", fontSize: 20 }} className="mt-0.5 shrink-0" />
      <Typography variant="body2" sx={{ color: "black.main", lineHeight: "20px" }}>
        {message}
      </Typography>
    </Box>
  );
};

export default ScratchPayUnavailableBanner;
